module.exports = __webpack_public_path__ + "static/media/mail.3bf4382e.png";